<template>
<div class="card card-table-two" v-loading='loading'>
    <el-row type='flex'>
        <el-col :span='20'>
            <label class="az-content-label" style="text-transform: none;margin-bottom:20px">Current Cash at Bank<span style="font-weight: 400;
                color: #97a3b9;
                text-transform: none;"> (as at {{yesterday}})</span>
            </label>
        </el-col>
        <el-col :span='4'>
            <span style='float:right;font-size:18px;'>
                <el-tooltip class="item" effect="light" content="Click to reset the cash limits" placement="left-start">
                    <el-button style="padding-top:0;padding-bottom:20px" type='text' @click="setting=!setting"><i class='fa fa-cog' style='color:gray;font-size:20px'></i></el-button>
                </el-tooltip>
            </span>
        </el-col>
    </el-row>
    <div class="card bd-0 mg-b-10" style="height:100%;" v-show="setting">
        <div class="card-header bd bd-b-0 tx-medium tx-black">
            Settings 
            <button type="button" class="close" aria-label="Close" style="float:right">
                <span aria-hidden="true" @click="setting=!setting">&times;</span>
            </button>
            <br><small>Alerts show when the fund’s cash at bank
            is above {{limit}}% of the total fund value;
            and / or the cash balance is below ${{amount}}. Please reset cash limits if required.</small>
        </div><!-- card-header -->
        <div class="card-body bd bd-t-0" style="height:130px">
            <el-form :inline="true" :model="formInline" class="demo-form-inline" size="mini">
                <el-form-item label="Max cash percentage(%):">
                    <el-input-number v-model.number="set_limit" :max='100' :rules="[
                { type: 'number',message: 'The number must be 0 - 100'}
                ]"></el-input-number>
                </el-form-item>
                <el-form-item label="Cash low amount($)">
                    <el-input v-model="set_amount" placeholder=""></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button class='bg-primary' type="primary" @click="onSubmit">OK</el-button>
                </el-form-item>
            </el-form>
        </div><!-- card-body -->
    </div><!-- card -->
    <div class="table-responsive tx-13">
        <table class="table table-striped mg-b-0">
        <thead>
            <tr>
                <th>Account</th>
                <th class='tx-right'>Balance</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for='account in cash_bank' :key='account[0]'>
                <td >{{account[0]}}</td>
                <td  class="tx-right tx-medium tx-inverse">{{account[1]}}</td>
            </tr>
            <tr>
                <td class="tx-medium">Total</td>
                <td class="tx-right tx-medium tx-inverse" >
                    <span v-show='!(total_cash<amount)'>{{total_cash}}</span>
                    <el-tooltip v-show='total_cash<amount' class="item" effect="light" :content="'cash balance is below $'+amount+'.'" placement="left-start">
                        <el-button type='text'><span class='tx-danger'>{{total_cash}}</span></el-button>
                    </el-tooltip>
                </td>
            </tr>
             <tr>
                <td class="tx-medium">Percentage</td>
                <td class="tx-right tx-medium tx-inverse">
                    <span v-show='!(limit<percentage)'>{{percentage.toFixed(2)+'%'}}</span>
                    <el-tooltip v-show='limit<percentage' class="item" effect="light" :content="'above '+limit+'% cash limits.'" placement="left-start">
                        <el-button type='text'><span class='tx-danger'>{{percentage.toFixed(2)+'%'}}</span></el-button>
                    </el-tooltip>
                    
                </td>
            </tr>
        </tbody>
        </table>
    </div><!-- table-responsive -->
</div><!-- card-dashboard-five -->
</template>
<script>
import dateformats from '../../../utils/dateformats'
export default {
    name:'fundcash',
    components: { 

    },
    data(){
        return{
            yesterday:dateformats.getDay(),
            total_cash:1,
            cash_bank:[],
            limit:1,
            percentage:1,
            amount:1,
            set_limit:10,
            set_amount:5000,
            setting:false,
            formInline:'',
            loading:true,
        }
    },
    created(){
        this.getCashData();
    },
    methods:{
        getCashData: function(){
            this.$api.funddashboard_api.fundCash(this.$route.params.fund_code).then(response =>{
                this.total_cash=response.data['total_cash']
                this.cash_bank=response.data['cash_bank']
                this.limit = response.data['limit']
                this.percentage = response.data['percentage']
                this.amount = response.data['amount']
                this.loading=false
                if(this.limit < this.percentage || this.total_cash < this.amount){
                    this.showAlert(this.limit,this.percentage,this.total_cash,this.amount)
                }
            });
        
        },
        showAlert(limit,percentage,total_cash,amount) {
            let msg = ''
            if(limit < percentage && total_cash < amount ){
                msg = 'The fund’s cash at bank is above 10% of the total fund value. \n The cash balance is below $5000.'
            }else if(limit < percentage){
                msg = 'The fund’s cash at bank is above 10% of the total fund value'
            }else if(total_cash < amount){
                msg = 'The fund’s cash balance is below $5000'
            }
            this.$notify({
                title: 'Alert - Cash at Bank',
                message: msg,
                type: 'warning',
                duration: 4500
            });
        },
        
    }
}
</script>
<style>
.el-notification__title {
    font-weight: 600;
    font-size: 13px;
    color: #303133;
    margin: 0;
}
.el-notification__icon {
    font-size: 16px;
}
.el-notification__content {
    font-size: 11px;
    line-height: 21px;
    margin: 6px 0 0;
    color: #606266;
    text-align: left;
}
.el-notification {
    width: 250px;
    padding: 12px 20px 12px 12px;
}
.el-notification__closeBtn {
    position: absolute;
    top: 15px;
    right: 15px;
    cursor: pointer;
    color: #909399;
    font-size: 13px;
}
</style>